import { motion } from 'framer-motion';

interface ProfileCardProps {
  displayName: string;
  avatarSeed: string;
  isOnline: boolean;
}

export function ProfileCard({ displayName, avatarSeed, isOnline }: ProfileCardProps) {
  const providers = [
    { name: 'Guest Access', connected: true, icon: '👤' },
    { name: 'Google Account', connected: false, icon: '🌐' },
    { name: 'Facebook Profile', connected: false, icon: '📱' },
  ];

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left select-none">
      <div className="space-y-5">
        {/* Profile Card Header */}
        <div className="flex items-center space-x-4">
          <div className="w-14 h-14 rounded-full bg-gradient-to-tr from-purple-600 to-pink-500 flex items-center justify-center text-xl font-black shadow-glow text-white border border-white/10">
            {avatarSeed.charAt(0).toUpperCase()}
          </div>
          <div className="flex flex-col text-left">
            <h3 className="font-display text-base font-black text-white tracking-wide">
              {displayName}
            </h3>
            {/* Online Badge status */}
            <div className="flex items-center space-x-1.5 mt-0.5">
              <span className={`w-2 h-2 rounded-full ${isOnline ? 'bg-emerald-500 animate-pulse' : 'bg-slate-600'}`} />
              <span className="text-[9px] font-black uppercase tracking-wider text-surface-400 font-mono">
                {isOnline ? 'Connected' : 'Offline'}
              </span>
            </div>
          </div>
        </div>

        {/* Account Linking Panel */}
        <div className="space-y-2.5 pt-3 border-t border-white/5">
          <label className="text-[9px] font-bold uppercase tracking-wider text-surface-500 block">
            Link Social Accounts
          </label>
          <div className="space-y-2">
            {providers.map((prov) => (
              <div
                key={prov.name}
                className="glass-light px-3 py-2 rounded-xl border border-white/5 flex items-center justify-between"
              >
                <div className="flex items-center space-x-2.5 text-xs text-surface-200">
                  <span>{prov.icon}</span>
                  <span className="font-bold text-[10px] uppercase tracking-wider">{prov.name}</span>
                </div>
                {prov.connected ? (
                  <span className="px-2 py-0.5 rounded bg-emerald-500/10 border border-emerald-500/20 text-[8px] font-black uppercase tracking-wider text-emerald-400">
                    Linked
                  </span>
                ) : (
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => alert(`Linking ${prov.name} is prepared for future authentication linking!`)}
                    className="px-2.5 py-0.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-[8px] font-black uppercase tracking-wider text-surface-300 hover:text-white cursor-pointer"
                  >
                    Link Account
                  </motion.button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProfileCard;
